// extracted by mini-css-extract-plugin
export default {"viewport":"SectionMarquee_viewport__8SfsJ","track":"SectionMarquee_track__V0r7y","fairwaybidLaufband":"SectionMarquee_fairwaybidLaufband__e2o99","row":"SectionMarquee_row__abgzT"};